import React from "react";
import { TextField } from "@mui/material";

// The 6-digit authenticator code (or, with allowBackup, a backup code)
export default function CodeInput({ value, onChange, allowBackup, autoFocus }) {
  return (
    <TextField
      fullWidth
      autoFocus={autoFocus}
      value={value}
      onChange={(event) =>
        onChange(
          allowBackup
            ? event.target.value.slice(0, 9)
            : event.target.value.replace(/\D/g, "").slice(0, 6)
        )
      }
      placeholder={allowBackup ? "xxxx-xxxx" : "123456"}
      inputProps={{
        inputMode: allowBackup ? "text" : "numeric",
        autoComplete: "one-time-code",
        "aria-label": allowBackup ? "Backup code" : "Authenticator code",
      }}
      className="tf-code-input"
    />
  );
}
